module.exports = __webpack_public_path__ + "img/Malen.657afd02.svg";